import Deals from './views/Deals'
import Deal from './views/Deal'
import Autos from './views/Autos'
import Auto from './views/Auto'
import StatusReasons from './views/StatusReasons'
import StatusReason from './views/StatusReason'
import Itineraries from './views/Itineraries'
import ItineraryFreights from './views/ItineraryFreights'
import Task from '@/modules/tasks/views/Task'
import Documents from './views/Documents'
import Document from './views/Document'

export default {
    routes: [
        {
            path: '/deals_new',
            name: 'DealsNew',
            components: { default: Deals },
            meta: {tab: 'deals', toolbars: ['Deals'] }
        },
        {
            path: '/deals_new/:id',
            name: 'DealNew',
            components: { default: Deals, right: Deal },
            meta: { toolbars: ['Deals'] }
        },



        {
          path: '/itineraries',
          name: 'Itineraries',
          component: Itineraries,
          meta: {tab: 'itineraries', toolbars: ['Itineraries'], setting_link: 'Freights'}
        },
        {
          path: '/itineraries/:id',
          name: 'Itinerary',
          components: {default: Itineraries, right: ItineraryFreights},
          meta: {tab: 'itineraries', toolbars: ['Itineraries'], setting_link: 'Freights'}
        },
        {
            path: '/deals_new/itinerary/:id',
            name: 'ItineraryFreights',
            components: {default: Deals, right: ItineraryFreights},
            meta: {tab: 'deals', toolbars: ['Deals'], setting_link: 'Freights'}
        },

        {
            path: '/auto',
            name: 'Autos',
            components: { default: Autos },
            meta: {tab: 'autos', setting_link: 'Autos', toolbars: ['Auto']}
        },
        {
            path: '/auto/:auto_id',
            name: 'Auto',
            components: { default: Autos, right: Auto },
            meta: {tab: 'autos', setting_link: 'Auto', toolbars: ['Auto']}
        },

        {
            path: '/status-reason',
            name: 'StatusReasons',
            components: { default: StatusReasons },
            meta: {setting_link: 'StatusReasons'}
        },
        {
            path: '/status-reason/:reason_id',
            name: 'StatusReason',
            components: { default: StatusReasons, right: StatusReason },
            meta: {setting_link: 'StatusReason'}
        },

        
        {
            path: '/deals_new/:dealid/task/:taskid',
            name: 'DealTask',
            components: { default: Deals, right: Task}
        },
        
        {
            path: '/documents',
            name: 'Documents',
            components: { default: Documents },
            meta: { toolbars: ['Documents'] }
        },
        {
            path: '/documents/:id',
            name: 'Document',
            components: { default: Documents, right: Document },
            meta: { toolbars: ['Documents'] }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/modules/deals/routes.js